import React from "react";
import { useTranslation } from "react-i18next";
import Avatar from 'react-avatar';
import { Modules, AuthRoutes, RouteParamsTypes } from "../../../../../enums";
import ElipsisText from "../../../../../components/ElipsisText";
import NoPropertyImg from '../../../../../assets/img/custom/no-property.jpeg';

interface PropertiesTabProps {
  properties?: any[];
}

const PropertiesTab: React.FC<PropertiesTabProps> = ({
  properties,
}) => {
  const { t } = useTranslation();

  const handleViewClick = (id: string) => {
    window.open(`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  return (
    <div className="card-body">
      <div className="row g-4">
        {
          properties && properties.length
            ?
            properties.map((property: any) => {
              return (
                <div className="col-md-3" key={property.id}>
                  <div className="card">
                    <Avatar className="card-img-top w-100 h-250px" src={property.picture_url || NoPropertyImg} name={property.name} maxInitials={2} />
                    <div className="card-body">
                      <ElipsisText
                        text={property.name}
                        width="100%"
                        className="h5 card-title text-decoration-underline hyperlink"
                        onClick={() => handleViewClick(property.id)}
                      />
                      <ElipsisText
                        text={property?.city_data?.name ?? '-'}
                        width="100%"
                        className="p card-text"
                      />
                    </div>
                  </div>
                </div>
              )
            })
            :
            (
              <p className="dataTables_empty text-center">{t("customers.addEdit.pageTexts.noPropertyAssigned")}</p>
            )
        }
      </div>
    </div>
  )
};

export default PropertiesTab;